/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Direct Mail specific Campaign
*/
export class V3DirectMailCampaign {
    /**
    * The name of the campaign.
    */
    'name'?: string;
    /**
    * The reference ID of the campaign.
    */
    'refId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "refId",
            "baseName": "ref_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3DirectMailCampaign.attributeTypeMap;
    }

    public constructor() {
    }
}

